import { ContentPanel } from '@/catalog-apps/components/AppPage2'
import { AppPageLoading } from '@/catalog-apps/components/AppPage2/AppPage2'
import { CatalogPageHeader } from '@/catalog-apps/components/AppPage2/ContentPanel/CatalogPageHeader'
import { TileGrid } from '@/catalog-apps/components/AppPage2/ContentPanel/TileGrid'
import { QueryErrorBoundary } from '@/catalog-apps/components/QueryErrorBoundary'
import { Suspense, useEffect, useRef } from 'react'
import { PageBuilderHeaderActions } from './PageBuilderHeaderActions'
import { EditTitleDescriptionFormPopover } from './EditTitleDescriptionForm'
import { useAppPageLayout } from '@/catalog-apps/components/AppPage2/useAppPageLayout'
import { Badge } from '@/components/shadcn/badge'

export function PageBuilderPage() {
  const headerActionsRef = useRef<HTMLDivElement>(null)
  return (
    <>
      <ContentPanel>
        <CatalogPageHeader titleAction={<TitleActions />}>
          <PageBuilderHeaderActions ref={headerActionsRef} />
        </CatalogPageHeader>
        <QueryErrorBoundary errorMessage={<span>Failed to fetch page layout</span>}>
          <Suspense fallback={<AppPageLoading />}>
            <TileGrid />
          </Suspense>
        </QueryErrorBoundary>
      </ContentPanel>
      {/* Page filters use a popover on the catalog app page (see HeaderActions). */}
    </>
  )
}

function TitleActions() {
  const { currentLayoutId } = useAppPageLayout()

  // useEffect(() => {
  //   setCurrentLayoutId(undefined)
  //   setTitleDesrcription({ title: 'New Page Name', description: 'New Page Description' })
  //   setDefaultContainers()
  // }, [setCurrentLayoutId, setTitleDesrcription, setDefaultContainers])

  return (
    <div className="flex items-center gap-x-5">
      <EditTitleDescriptionFormPopover />
      <Badge className="h-5" variant={currentLayoutId ? 'success' : 'warning'}>
        {currentLayoutId ? 'Saved' : 'New'}
      </Badge>
    </div>
  )
}
